/* d.nuvo Skin Quiz: one question at a time, then a duo recommendation.
   General product guidance only. No diagnosis, no health claims. */
(function () {
  var root = document.querySelector('[data-nq]');
  if (!root) return;
  var dataEl = document.querySelector('[data-nq-data]');
  var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var P = D.products;

  var NAMES = { vitc: 'Vitamin C Ampoule', calm: 'Calming Ampoule', water: 'Water Cream', eye: 'Eye Cream', sun: 'Aqua C Dual Sun Serum (50 ml)', toner: 'Essential Toner' };
  var ROLE = {
    vitc: 'Your hero step for a brighter-looking, more even tone',
    calm: 'Your hero step for comfort if skin is blemish-prone or easily upset',
    water: 'Light hydration that also preps skin for makeup',
    eye: 'Extra care for the delicate eye area',
    sun: 'The final daytime step, especially for days out and about',
    toner: 'A light prep step before your treatment'
  };
  var WORD = { vitc: 'Glow', calm: 'Calm', water: 'Hydrate', eye: 'Eye' };

  var qs = Array.prototype.slice.call(root.querySelectorAll('[data-nq-q]'));
  var bar = root.querySelector('[data-nq-bar]');
  var barWrap = root.querySelector('[role="progressbar"]');
  var stepEl = root.querySelector('[data-nq-step]');
  var backBtn = root.querySelector('[data-nq-back]');
  var progress = root.querySelector('[data-nq-progress]');
  var nav = root.querySelector('[data-nq-nav]');
  var result = root.querySelector('[data-nq-result]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var answers = {}, idx = 0, plan = null;

  var fmt;
  try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-SG', { style: 'currency', currency: D.currency || 'SGD', minimumFractionDigits: 0, maximumFractionDigits: 0 }); }
  catch (e) { fmt = { format: function (n) { return (D.currency || '') + ' ' + Math.round(n); } }; }
  function money(c) { return fmt.format(c / 100); }

  function show(n) {
    idx = n;
    qs.forEach(function (q, i) {
      var on = i === n;
      q.hidden = !on; q.classList.toggle('is-active', on);
    });
    result.hidden = true; progress.hidden = false; nav.hidden = false;
    var pos = n + 1;
    bar.style.width = (pos / qs.length * 100) + '%';
    barWrap.setAttribute('aria-valuenow', pos);
    stepEl.textContent = 'Question ' + pos + ' of ' + qs.length;
    backBtn.hidden = n === 0;
    // Mark the previously chosen option
    var key = qs[n].getAttribute('data-nq-q');
    qs[n].querySelectorAll('.nq__opt').forEach(function (b) { b.classList.toggle('is-selected', answers[key] === b.getAttribute('data-value')); });
    var h = qs[n].querySelector('h2'); if (h) h.focus({ preventScroll: true });
    if (!reduce && root.scrollIntoView) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function recommend(a) {
    var vit = 0, calm = 0;
    if (a.focus === 'bright') vit += 3; else if (a.focus === 'calm') calm += 3; else vit += 1;
    if (a.afternoon === 'dull') vit += 2; else if (a.afternoon === 'oily' || a.afternoon === 'reactive') calm += 2; else if (a.afternoon === 'tight') calm += 1;
    if (a.react === 'often') calm += 2; else if (a.react === 'rarely') vit += 1;
    var hero = calm > vit ? 'calm' : 'vitc';
    var partner = a.area === 'eyes' ? 'eye' : 'water';
    var extras = a.steps === '4' ? ['sun', 'toner'] : (a.steps === '3' ? ['sun'] : []);
    var keys = [hero, partner].concat(extras).filter(function (k) { return P[k] && P[k].found && P[k].available; });
    return { hero: hero, partner: partner, extras: extras, keys: keys };
  }

  function whyText(a, r) {
    var bits = [];
    bits.push(r.hero === 'vitc'
      ? 'You told us you would like a brighter, fresher-looking tone, so we start with the Vitamin C Ampoule.'
      : 'Comfort came first in your answers, so we start with the gentler Calming Ampoule.');
    bits.push(r.partner === 'eye'
      ? 'The Eye Cream adds care where late nights and screens show first.'
      : 'Water Cream keeps the rest of your face comfortably hydrated.');
    if (r.extras.indexOf('sun') > -1) bits.push('Sun Serum (50 ml) finishes your daytime routine.');
    if (r.extras.indexOf('toner') > -1) bits.push('Essential Toner is a light prep step before the ampoule.');
    if (a.react === 'often') bits.push('Because your skin reacts easily, add one product at a time and patch test first.');
    return bits.join(' ');
  }

  function render() {
    plan = recommend(answers);
    var a = answers;
    root.querySelector('[data-nq-title]').textContent = WORD[plan.hero] + ' & ' + WORD[plan.partner] + ' Duo' + (plan.extras.length ? ' + ' + (plan.extras.length === 2 ? 'daytime & prep' : 'daytime protection') : '');
    root.querySelector('[data-nq-why]').textContent = whyText(a, plan);
    var list = root.querySelector('[data-nq-list]'); list.innerHTML = '';
    var total = 0;
    plan.keys.forEach(function (k) {
      var p = P[k]; total += p.price;
      var li = document.createElement('li'); li.className = 'nq__item';
      var img = document.createElement('div'); img.className = 'nq__thumb';
      if (p.image) { var i = document.createElement('img'); i.src = p.image; i.alt = ''; i.loading = 'lazy'; img.appendChild(i); }
      var txt = document.createElement('div'); txt.className = 'nq__item-text';
      var a1 = document.createElement('a'); a1.href = p.url; a1.textContent = NAMES[k];
      var s = document.createElement('span'); s.textContent = ROLE[k];
      txt.appendChild(a1); txt.appendChild(s);
      var pr = document.createElement('span'); pr.className = 'nq__price'; pr.textContent = money(p.price);
      li.appendChild(img); li.appendChild(txt); li.appendChild(pr); list.appendChild(li);
    });
    root.querySelector('[data-nq-total]').textContent = money(total);
    root.querySelector('[data-nq-status]').textContent = '';
    var addBtn = root.querySelector('[data-nq-add]');
    addBtn.disabled = plan.keys.length < 2;
    qs.forEach(function (q) { q.hidden = true; });
    progress.hidden = true; nav.hidden = true; result.hidden = false;
    var h = root.querySelector('[data-nq-title]'); h.focus({ preventScroll: true });
    if (root.scrollIntoView) root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }

  qs.forEach(function (q, i) {
    q.querySelectorAll('.nq__opt').forEach(function (b) {
      b.addEventListener('click', function () {
        answers[q.getAttribute('data-nq-q')] = b.getAttribute('data-value');
        q.querySelectorAll('.nq__opt').forEach(function (o) { o.classList.toggle('is-selected', o === b); });
        setTimeout(function () { if (i < qs.length - 1) show(i + 1); else render(); }, reduce ? 0 : 220);
      });
    });
  });
  backBtn.addEventListener('click', function () { if (idx > 0) show(idx - 1); });
  root.querySelector('[data-nq-retake]').addEventListener('click', function () { answers = {}; show(0); });

  root.querySelector('[data-nq-add]').addEventListener('click', function () {
    var btn = this, status = root.querySelector('[data-nq-status]');
    if (!plan) return;
    var name = WORD[plan.hero] + ' & ' + WORD[plan.partner] + ' Duo';
    var items = plan.keys.map(function (k, n) {
      var it = { id: P[k].variant, quantity: 1 };
      if (n < 2) it.properties = { 'Duo': name };
      return it;
    });
    var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…'; status.textContent = '';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        btn.textContent = 'Added ✓'; status.textContent = 'Added to your bag.';
        var t = document.querySelector('[data-cart-toggle]'); if (t) t.click();
      })
      .catch(function () { btn.textContent = label; status.textContent = 'Sorry, something could not be added. It may have just sold out.'; })
      .then(function () { setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600); });
  });

  show(0);
})();
